import React, { useState, useEffect, } from 'react';
import {
  Container,
  ContainerDivs,
  Label,
  DivAddEmp,
  AddEmp,
  DadosStdt,
  SpanFrequency,
  ToGoBack,
  DivDados,
  List,
  DivBimRow,
  DivBimHeader,
  DivBimCell,
  DivSignatureArea,
  Emp,
  SignatureBlock,
  Line,
  DivBimTable,
  DivNameMatter,
  SpanNameMatter,
  Grade,
  PrintButton,
  SignMessageButtonText,
  SignMessageButtonTextBold,
  Preview,
  ContLogo,
  InfoContainer,
  UpContainer
} from './style';


import GlobalStyle from './style';

import {
  allTheBulletinsGrades,
  getIstQuarter,
  getIIndQuarter,
  getIIIrdQuarter,
  clssInfo,
  fetchLogo,
  GetMatter
} from '../../Api';

//import GlobalStyle from './style';

import { IoCheckmarkSharp, IoCloseSharp } from "react-icons/io5";

import { FcSurvey } from "react-icons/fc";

import { useNavigate, useParams } from 'react-router-dom';

import LoadingSpinner from '../../components/Loading';
import { NotaRec, LegendaNotas, notaDoPeriodo } from '../../components/Recuperacao';

const AllTheBulletins = () => {

  const navigate = useNavigate()
  const [bimestre, setBimestre] = useState({});
  const [Istbimonthly, setIstBimonthly] = useState([]);
  const [IIndbimonthly, setIIndBimonthly] = useState([]);
  const [IIIrdbimonthly, setIIIrdBimonthly] = useState([]);
  const [BulletinsIst, setBulletinsIst] = useState([]);
  const [BulletinsIInd, setBulletinsIInd] = useState([]);
  const [BulletinsIIIrd, setBulletinsIIIrd] = useState([]);
  const [Bulletins, setBulletins] = useState([]);
  const [cla$$, setClass] = useState([]);
  const [dataCla$$, setdataClass] = useState([]);
  const [teacher, setTeacher] = useState([]);
  const [nameSchool, setNameSchool] = useState('')
  const [logoUrl, setLogoUrl] = useState('');
  const [matters, setMatter] = useState([]);
  const [loading, setLoading] = useState(true);

  const { idClass } = useParams();
  const { idBim } = useParams();

  useEffect(() => {
    (async () => {
      setLoading(true);
      console.log("idClass", idClass, "idBim", idBim)
      const idSchool = JSON.parse(sessionStorage.getItem("id-school"));
      // materias da escola na ordem do usuario (EF no fim)
      try {
        const resMatter = await GetMatter(idSchool);
        const EF_NAME = 'EDUCAÇÃO FÍSICA';
        const nrm = (s = '') => s.trim().toUpperCase();
        const rawMatters = resMatter.data.data || [];
        const orderedMatters = [...rawMatters].sort((a, b) => {
          const aEF = nrm(a.name) === EF_NAME;
          const bEF = nrm(b.name) === EF_NAME;
          if (aEF) return 1;
          if (bEF) return -1;
          return 0;
        });
        setMatter(orderedMatters);
      } catch (e) {
        console.error('Erro ao buscar materias:', e);
      }
      const nameSchool = sessionStorage.getItem("School");
      setNameSchool(nameSchool)
      const res = await allTheBulletinsGrades({
        idClass,
        id_ivThQuarter: idBim,
      });
      console.log("resposta boletins", res);
      // Aqui você pode setar os dados no estado, se quiser
      setBulletins(res.data.data.boletins);
      setClass(res.data.data.turma);
      setBimestre(res.data.data.bimestre);

      const regentTeachers = res.data.data.turma.regente;

      if (regentTeachers.length > 0) {
        setTeacher(regentTeachers[0]); // Se quiser só o primeiro
        // OU
        // setTeacher(regentTeachers); // Se quiser todos em um array
      } else {
        setTeacher(null);
      }

      const resClass = await clssInfo(idClass);
      setdataClass(resClass)
      const $yearClass = resClass.data.data.find(clss => {
        return clss.year
      })
      const year = $yearClass.year
      const IstQuarter = await getIstQuarter(year, idSchool)
      const IIndQuarter = await getIIndQuarter(year, idSchool)
      const IIIrdQuarter = await getIIIrdQuarter(year, idSchool)
      const i = IstQuarter.data.data.find(res => res) || null;
      const ii = IIndQuarter.data.data.find(res => res) || null;
      const iii = IIIrdQuarter.data.data.find(res => res) || null;
      setIstBimonthly([i].filter(res => res !== null));
      setIIndBimonthly([ii].filter(res => res !== null));
      setIIIrdBimonthly([iii].filter(res => res !== null));

      const resIst = await allTheBulletinsGrades({
        idClass,
        id_iStQuarter: i._id,
      });

      setBulletinsIst(resIst.data.data.boletins);

      console.log("resIst", resIst)

      const resIInd = await allTheBulletinsGrades({
        idClass,
        id_iiNdQuarter: ii._id,
      });

      setBulletinsIInd(resIInd.data.data.boletins);

      console.log("resIInd", resIInd)

      const resIIIrd = await allTheBulletinsGrades({
        idClass,
        id_iiiRdQuarter: iii._id,
      });

      setBulletinsIIIrd(resIIIrd.data.data.boletins);

      console.log("resIInd", resIIIrd)

      const cachedLogo = localStorage.getItem(`school-logo-${idSchool}`);
      //const cachedLogoId = localStorage.getItem(`school-logo-id-${idSchool}`);

      if (cachedLogo) {
        console.log('busca pelo storage local')
        setLogoUrl(cachedLogo);
        //setlogoId(cachedLogoId);
      } else {

        console.log('busca no s3')
        const logoRes = await fetchLogo(idSchool);

        console.log('busca logo', logoRes)
        if (logoRes?.url) {
          setLogoUrl(logoRes.url);
          //setlogoId(logoRes._id);
          localStorage.setItem(`school-logo-${idSchool}`, logoRes.url);
          localStorage.setItem(`school-logo-id-${idSchool}`, logoRes._id);

        }
      }

      setLoading(false);
    })();

  }, [idBim, idClass]);

  const messageButtonClick = () => {
    navigate(-1);
  };

  const handlePrint = () => {
    window.print();
  };

  console.log("Bulletins", Bulletins)
  console.log("BulletinsIst", BulletinsIst)
  console.log("cla$$", cla$$)
  console.log("teacher", teacher)
  console.log("bimonthly", Istbimonthly)

  // ordena as materias conforme a ordem definida pelo usuario (campo `order`
  // vindo do GetMatter), com a Educacao Fisica sempre no final.
  const norm = (s = '') => s.trim().toUpperCase();
  const sortByUserOrder = (entries) => {
    const orderIndex = new Map((matters || []).map((m, i) => [norm(m.name), i]));
    const big = Number.MAX_SAFE_INTEGER;
    return [...entries].sort((a, b) => {
      const ia = orderIndex.has(norm(a.matterName)) ? orderIndex.get(norm(a.matterName)) : big;
      const ib = orderIndex.has(norm(b.matterName)) ? orderIndex.get(norm(b.matterName)) : big;
      return ia - ib;
    });
  };



  return (
    <Container>
      {<GlobalStyle />}
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <ContainerDivs>
            <div className="no-print">
              <h3>Atenção antes de imprimir</h3>
              <p>
                Caso o boletim possua muitas matérias e não caiba totalmente em uma única folha,
                diminua a <strong>escala de impressão</strong> nas configurações da impressora.
                Sugestão: <strong>90%</strong>, <strong>85%</strong> ou <strong>80%</strong>.
              </p>
            </div>
            <PrintButton className="no-print" onClick={handlePrint}>
              Imprimir
            </PrintButton>
            {Bulletins
              .slice()
              .sort((a, b) => a.nome.localeCompare(b.nome))
              .map((aluno, index) => {
                const alunoIst = BulletinsIst.find(item => item.id === aluno.id);
                const bim1 = Istbimonthly.find(item => item.bimonthly === "1º BIMESTRE");

                const alunoIInd = BulletinsIInd.find(item => item.id === aluno.id);
                const bim2 = IIndbimonthly.find(item => item.bimonthly === "2º BIMESTRE");

                const alunoIIIrd = BulletinsIIIrd.find(item => item.id === aluno.id);
                const bim3 = IIIrdbimonthly.find(item => item.bimonthly === "3º BIMESTRE");

                console.log('bim1 averageGrade:', bim1?.averageGrade);
                console.log('bim1 totalGrade:', bim1?.totalGrade);

                return (
                  <DivAddEmp id="containerDivs" key={aluno.id || index}>
                    <ContLogo>
                      {(logoUrl) && (
                        <Preview src={logoUrl} alt="Logo da escola" />
                      )}
                      <h2>Boletim</h2>
                    </ContLogo>
                    <AddEmp>
                      <h3>4º Bimestre</h3>
                    </AddEmp>
                    <DadosStdt>
                      <UpContainer>
                        <InfoContainer>
                          <span><strong>Escola:</strong> {nameSchool}</span>

                          <span>
                            <strong>Série:</strong> {dataCla$$?.data?.data?.[0]?.serie} - {dataCla$$?.data.data?.[0]?.level}
                          </span>

                          <span>
                            <strong>Turma:</strong> {dataCla$$?.data?.data?.[0]?.name}
                          </span>

                          <span>
                            <strong>Ano Letivo:</strong> {dataCla$$?.data?.data?.[0]?.year}
                          </span>

                          <span>
                            <strong>Professor(a):</strong> {cla$$.regente.map(prof => prof.nome).join(", ")}
                          </span>

                          <span>
                            <strong>Aluno(a):</strong> {aluno.nome}
                          </span>
                        </InfoContainer>
                        <SpanFrequency>
                          <span>
                            <IoCheckmarkSharp color='#00fa00' fontSize="30px" /> Presenças: {aluno.frequencia.totalPresencas} |{" "}
                            <IoCloseSharp color='#ff050a' fontSize="30px" /> Faltas: {aluno.frequencia.totalFaltas}
                          </span>
                          <span>
                            <FcSurvey fontSize="25px" /> Faltas Justificadas: {aluno.frequencia.totalFaltasJustificadas}
                          </span>
                        </SpanFrequency>
                      </UpContainer>
                      <LegendaNotas total={bimestre.totalGrade ? parseFloat(bimestre.totalGrade).toFixed(1) : '0.0'} media={bimestre.averageGrade ? parseFloat(bimestre.averageGrade).toFixed(1) : '0.0'} totalLabel="Total" mediaLabel="Média" />
                    </DadosStdt>

                    <DivDados>
                      <List>
                        {sortByUserOrder(Object.entries(aluno.totalPorMateria)
                          .map(([matterName, grade]) => ({
                            matterName,
                            grade
                          })))
                          
                          .map(grd => {
                            const isHistorico =
                              !grd.grade?.atividades ||
                              grd.grade.atividades.length === 0 ||
                              grd.grade.atividades.every(a => a.idActivity === null);

                            const isHistorico1Bim =
                              !alunoIst?.totalPorMateria?.[grd.matterName]?.atividades ||
                              alunoIst.totalPorMateria[grd.matterName].atividades.length === 0 ||
                              alunoIst.totalPorMateria[grd.matterName].atividades.every(
                                a => a.idActivity === null
                              );
                            const isHistorico2Bim =
                              !alunoIInd?.totalPorMateria?.[grd.matterName]?.atividades ||
                              alunoIInd.totalPorMateria[grd.matterName].atividades.length === 0 ||
                              alunoIInd.totalPorMateria[grd.matterName].atividades.every(
                                a => a.idActivity === null
                              );
                            const isHistorico3Bim =
                              !alunoIIIrd?.totalPorMateria?.[grd.matterName]?.atividades ||
                              alunoIIIrd.totalPorMateria[grd.matterName].atividades.length === 0 ||
                              alunoIIIrd.totalPorMateria[grd.matterName].atividades.every(
                                a => a.idActivity === null
                              );
                            return (
                              <Emp key={grd.matterName}>
                                <DivNameMatter>
                                  <SpanNameMatter>{grd.matterName}</SpanNameMatter>
                                </DivNameMatter>
                                <Grade>
                                  <DivBimTable>
                                    <DivBimRow>
                                      <DivBimHeader>1º Bim</DivBimHeader>
                                      <DivBimCell
                                        grade={
                                          alunoIst && alunoIst.totalPorMateria && alunoIst.totalPorMateria[grd.matterName] !== undefined
                                            ? notaDoPeriodo(alunoIst.totalPorMateria[grd.matterName])
                                            : 0
                                        }
                                        averageGrade={bim1 ? parseFloat(bim1.averageGrade) : 0}
                                        totalGrade={bim1 ? parseFloat(bim1.totalGrade) : 0}
                                        isHistorico={isHistorico1Bim}
                                      >
                                        {(() => {
                                          const val = alunoIst && alunoIst.totalPorMateria && alunoIst.totalPorMateria[grd.matterName] !== undefined
                                            ? <NotaRec g={alunoIst.totalPorMateria[grd.matterName]} />
                                            : '-';
                                          return val;
                                        })()}
                                      </DivBimCell>
                                    </DivBimRow>

                                    <DivBimRow>
                                      <DivBimHeader>2º Bim</DivBimHeader>
                                      <DivBimCell
                                        grade={
                                          alunoIInd && alunoIInd.totalPorMateria && alunoIInd.totalPorMateria[grd.matterName] !== undefined
                                            ? notaDoPeriodo(alunoIInd.totalPorMateria[grd.matterName])
                                            : 0
                                        }
                                        averageGrade={bim2 ? parseFloat(bim2.averageGrade) : 0}
                                        totalGrade={bim2 ? parseFloat(bim2.totalGrade) : 0}
                                        isHistorico={isHistorico2Bim}
                                      >
                                        {(() => {
                                          const val = alunoIInd && alunoIInd.totalPorMateria && alunoIInd.totalPorMateria[grd.matterName] !== undefined
                                            ? <NotaRec g={alunoIInd.totalPorMateria[grd.matterName]} />
                                            : '-';
                                          return val;
                                        })()}
                                      </DivBimCell>
                                    </DivBimRow>

                                    <DivBimRow>
                                      <DivBimHeader>3º Bim</DivBimHeader>
                                      <DivBimCell
                                        grade={
                                          alunoIIIrd && alunoIIIrd.totalPorMateria && alunoIIIrd.totalPorMateria[grd.matterName] !== undefined
                                            ? notaDoPeriodo(alunoIIIrd.totalPorMateria[grd.matterName])
                                            : 0
                                        }
                                        averageGrade={bim3 ? parseFloat(bim3.averageGrade) : 0}
                                        totalGrade={bim3 ? parseFloat(bim3.totalGrade) : 0}
                                        isHistorico={isHistorico3Bim}
                                      >
                                        {(() => {
                                          const val = alunoIIIrd && alunoIIIrd.totalPorMateria && alunoIIIrd.totalPorMateria[grd.matterName] !== undefined
                                            ? <NotaRec g={alunoIIIrd.totalPorMateria[grd.matterName]} />
                                            : '-';
                                          return val;
                                        })()}
                                      </DivBimCell>
                                    </DivBimRow>

                                    <DivBimRow>
                                      <DivBimHeader>4º Bim</DivBimHeader>
                                      <DivBimCell
                                        grade={notaDoPeriodo(grd.grade)}
                                        averageGrade={parseFloat(bimestre.averageGrade) || 0}
                                        totalGrade={parseFloat(bimestre.totalGrade) || 0}
                                        isHistorico={isHistorico}
                                      >
                                        <NotaRec g={grd.grade} />
                                      </DivBimCell>
                                    </DivBimRow>
                                  </DivBimTable>
                                </Grade>
                              </Emp>
                            )
                          })}
                      </List>
                    </DivDados>

                    <DivSignatureArea>
                      <SignatureBlock>
                        <Line />
                        <Label>Assinatura do Professor</Label>
                      </SignatureBlock>

                      <SignatureBlock>
                        <Line />
                        <Label>Assinatura dos Pais ou Responsável</Label>
                      </SignatureBlock>
                    </DivSignatureArea>
                  </DivAddEmp>
                );
              })}
          </ContainerDivs>
          <ToGoBack onClick={messageButtonClick}>
            <SignMessageButtonText>Voltar para a</SignMessageButtonText>
            <SignMessageButtonTextBold>Turma</SignMessageButtonTextBold>
          </ToGoBack>
        </>
      )
      }
    </Container >
  );

}

export default AllTheBulletins